<script lang="ts" setup>
import Button from '@/components/Button.vue';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';

import { focusInput } from '../utils/focusInput.js';
import * as l from './StartConsultationButton.loc.js';

interface Props {
  variant?: 'primary' | 'secondary';
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
});

const t = useTranslate();

function handleClick() {
  focusInput.emit();
}
</script>

<template>
  <Button
    :variant="variant"
    href="#start"
    @click.prevent="handleClick"
  >
    {{ t(l.startConsultation) }}
  </Button>
</template>
